import client from './client';

export const getAdminStudents = () => client.get('/admin/students/');
export const getAdminStudentHistory = (studentId) => client.get(`/admin/students/${studentId}/history`);
export const forceCompleteStudentSessions = (studentId) => client.post(`/admin/students/${studentId}/force-complete`);
export const deleteAdminStudent = (studentId) => client.delete(`/admin/students/${studentId}`);
